import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { PortalTemplate } from "src/app/_api/models/portal-template.model";
import { PortalTemplateService } from "src/app/modules/admin/_api/services/portal-template.service";
import { LanguageService } from "../../services/language.service";
import { LocalStorageService } from "../../services/local-storage.service";

@Component({
  selector: 'app-portal-template-timetype-selector',
  templateUrl: './portal-template-timetype-selector.component.html',
  styleUrls: ['./portal-template-timetype-selector.component.css']
})
export class PortalTemplateTimetypeSelectorComponent implements OnInit {
  readonly portalTemplateStorageKey = 'portal-template-storage-key';
  readonly fallbackPortalTemplateId = 1;

  @Output() portalTemplateValueChanged = new EventEmitter<number>();

  portalTemplates: PortalTemplate[] = [];
  selectedTemplate: any;

  constructor(public languageService: LanguageService, private portalTemplatesService: PortalTemplateService, private localStorageService: LocalStorageService) {}

  async ngOnInit() {
    await this.load();
    this.selectTemplate();
  }

  onPortalTemplateValueChanged(e: any) {
    this.localStorageService.set(this.portalTemplateStorageKey, e.value);
    this.portalTemplateValueChanged.emit(e.value);
  }

  getCurrentPortalTemplate(): number {
    return this.localStorageService.get(this.portalTemplateStorageKey) ?? this.fallbackPortalTemplateId;
  }

  private async load() {
    this.portalTemplates = await this.portalTemplatesService.getPortalTemplates().toPromise();
  }

  private selectTemplate() {
    let template = this.localStorageService.get(this.portalTemplateStorageKey);

    if (template === null) { template = this.fallbackPortalTemplateId; }

    const exists = this.portalTemplates.some(x => x.PortalTemplateId === template);

    if (!exists) {
      this.localStorageService.delete(this.portalTemplateStorageKey);
      return;
    }

    this.selectedTemplate = template;
  }
}
